<div class="astrea-promotions">

    <div class="d-flex j-c-center mb-4 w-100">
        <div class="title t-center mb-3">
            <h2 class="mb-3">
                {{ 'home.promotions.text1' | translate }}
            </h2>
            <p>{{ 'home.promotions.text2' | translate }}</p>
        </div>
    </div>

    <div class="promotions-grid">
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-book img-responsive" src="/assets/images/home/home-book-1.png" alt="'home.promotions.title1' | translate" />
            <h3>{{ 'home.promotions.title1' | translate }}</h3>
            <a routerLink="/doctrine" class="btn btn-green" [title]="'home.promotions.title1' | translate" mat-button>
                {{ 'home.promotions.see_title1' | translate }}
            </a>
        </div>
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-book img-responsive" src="/assets/images/home/home-book-2.png" [alt]="'home.promotions.title2' | translate" />
            <h3>{{ 'home.promotions.title2' | translate }}</h3>
            <a routerLink="/collections" class="btn btn-green" [title]="'home.promotions.title2' | translate" mat-button>
                {{ 'home.promotions.see_title2' | translate }}
            </a>
        </div>
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-responsive" src="/assets/images/astrea-brand/av-logo-green.png" alt="Astrea Virtual" />
            <div class="av-info">
                <p>{{ 'home.promotions.av1' | translate }}</p>
                <br>
                <p>{{ 'home.promotions.av2' | translate }}</p>
            </div>
            <a routerLink="/astreavirtual" class="btn btn-green" title="Novedades" mat-button>
                {{ 'home.promotions.see_more' | translate }}
            </a>
        </div>
    </div>

</div>
